import { render } from "./basic-content-v1.vue?vue&type=template&id=74dd863e&scoped=true"
import script from "./basic-content-v1.vue?vue&type=script&lang=js"
export * from "./basic-content-v1.vue?vue&type=script&lang=js"

import "./basic-content-v1.vue?vue&type=style&index=0&id=74dd863e&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74dd863e"]])

export default __exports__